var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smile-box"},[_c('a',{staticClass:"alert-btn",attrs:{"href":"https://a.app.qq.com/dom/micro/open.jsp?pkgname=com.noahyijie.ygb"}}),_vm._v(" "),_c('img',{staticClass:"alert-close",attrs:{"src":require("../../assets/images/close.png")},on:{"click":function($event){return _vm.$emit('close-modal')}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53144266","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resultModal/smile-success.vue
// module id = null
// module chunks = 